import { PageLayout } from '../components/PageLayout';
import { AIIntelligenceSection } from '../components/sections/AIIntelligenceSection';

export const HowItWorks = () => (
    <PageLayout>
        <AIIntelligenceSection />
    </PageLayout>
);
